module.exports = __webpack_public_path__ + "img/G.e86209bf.jpg";